import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import {
  loadAllCenterProductPrice,
  loadSingleCenterProductPrice,
} from "./PriceList.slice";

import {
  loadAllCenterProductPriceAPI,
  loadSingleCenterProductPriceAPI,
} from "./PriceList.api";

export const LOAD_ALL_CENTER_PRODUCT_PRICE = {
  LOADING: "Load all center product price loading",
  SUCCESS: "Load all center product price success",
  ERROR: "Load all center product price error",
};

export const LOAD_SINGLE_CENTER_PRODUCT_PRICE = {
  LOADING: "Load single center product price loading",
  SUCCESS: "Load single center product price success",
  ERROR: "Load single center product price error",
};

function* loadAllCenterProductPriceWorker(action) {
  const { payload } = action;
  try {
    const data = yield call(loadAllCenterProductPriceAPI, payload);
    yield put(loadAllCenterProductPrice(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_CENTER_PRODUCT_PRICE.ERROR, error });
  }
}

function* loadSingleCenterProductPriceSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleCenterProductPriceAPI, payload);
    yield put(loadSingleCenterProductPrice(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_CENTER_PRODUCT_PRICE.ERROR, error });
  }
}

export function* loadAllCenterProductPriceSaga() {
  yield takeLatest(
    LOAD_ALL_CENTER_PRODUCT_PRICE.LOADING,
    loadAllCenterProductPriceWorker
  );
}

export function* loadSingleCenterProductPriceSaga() {
  yield takeLatest(
    LOAD_SINGLE_CENTER_PRODUCT_PRICE.LOADING,
    loadSingleCenterProductPriceSagaWorker
  );
}
